export enum Routes {
  NotificationRouter = "*",
  NotificationSearchPageRouter = "/notification/search",
  NotificationCreatePageRouter = "/notification/new",
  NotificationEditPageRouter = "/notification/:id/edit",
  NotificationLogSearchPageRouter = "/notification/log",
  NotificationCalendarPageRouter = "/notification/calendar",
  NotificationVehicleTimelinePageRouter = "/notification/calendar/vehicles",
}
